// extracted by mini-css-extract-plugin
export default {"select-container":"Select_select-container__I4rSl","select-label":"Select_select-label__yqkby","select-detailing":"Select_select-detailing__e+y6o","counter":"Select_counter__2b8vT"};